(() => {
  if (window.__belantaraFinderTapSaveReady) return;
  window.__belantaraFinderTapSaveReady = true;

  const SITE_ID = 'VVcDmZ';
  const LIST_ID = 'X2ixBT';
  const TAP_LOGO = 'https://cdn.shopify.com/s/files/1/0554/2471/2762/files/belantara_email_logo.png?v=1775655622';
  const normalizeEmail = value => (value || '').trim().toLowerCase();
  const validEmail = value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const clean = object => Object.fromEntries(
    Object.entries(object || {}).filter(([, value]) => value !== '' && value != null)
  );

  function rememberedEmail() {
    try {
      return normalizeEmail(localStorage.getItem('belantara_tap_email'));
    } catch (_) {
      return '';
    }
  }

  function consentEmail() {
    try {
      return normalizeEmail(localStorage.getItem('belantara_tap_marketing_consent_email'));
    } catch (_) {
      return '';
    }
  }

  function rememberEmail(email) {
    if (window.BelantaraIdentity?.remember) {
      window.BelantaraIdentity.remember(email);
      return;
    }
    try {
      localStorage.setItem('belantara_tap_email', email);
    } catch (_) {}
  }

  function rememberConsent(email) {
    try {
      localStorage.setItem('belantara_tap_marketing_consent_email', email);
    } catch (_) {}
  }

  function knownEmail(form) {
    if (window.BelantaraIdentity?.email) {
      return window.BelantaraIdentity.email(form.dataset.customerEmail);
    }
    return normalizeEmail(form.dataset.customerEmail) || rememberedEmail();
  }

  async function isRecognized(form) {
    if (window.BelantaraIdentity?.isKnown) {
      return window.BelantaraIdentity.isKnown(form.dataset.customerEmail);
    }
    return Boolean(knownEmail(form));
  }

  function isTapContext() {
    return document.documentElement.classList.contains('ff-tap');
  }

  function context() {
    const params = new URLSearchParams(location.search);
    const tap = isTapContext();
    return clean({
      source_type: params.get('src') || params.get('source') || (tap ? 'tap' : 'website'),
      event_code: params.get('event') || '',
      venue_code: params.get('venue') || '',
      touchpoint_code: params.get('touchpoint') || 'fragrance-finder',
      fragrance_code: '',
      intent_code: 'save_preference',
      topic_code: params.get('topic') || '',
      tag_code: params.get('tag') || '',
      interaction_method: params.get('method') || (tap ? 'nfc' : 'web')
    });
  }

  function identify(email, properties) {
    const payload = clean({ email, ...properties });
    if (window.klaviyo?.identify) return Promise.resolve(window.klaviyo.identify(payload));
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', clean({ '$email': email, ...properties })]);
    return Promise.resolve();
  }

  function track(name, properties) {
    if (window.klaviyo?.track) return Promise.resolve(window.klaviyo.track(name, clean(properties)));
    window._learnq = window._learnq || [];
    window._learnq.push(['track', name, clean(properties)]);
    return Promise.resolve();
  }

  async function subscribe(email) {
    const params = new URLSearchParams(location.search);
    const tap = isTapContext();
    const source = tap ? 'belantara_tap' : 'fragrance_finder';
    const properties = clean({
      marketing_consent_source: source,
      marketing_consent_context: params.get('src') || params.get('source') || (tap ? 'tap' : 'website'),
      marketing_consent_event: params.get('event') || '',
      marketing_consent_venue: params.get('venue') || '',
      marketing_consent_touchpoint: params.get('touchpoint') || 'fragrance-finder',
      marketing_consent_intent: 'save_preference',
      marketing_consent_tag: params.get('tag') || '',
      marketing_consent_method: params.get('method') || (tap ? 'nfc' : 'web')
    });

    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(SITE_ID)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: tap ? 'Belantara Tap' : 'Fragrance Finder',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties,
                    subscriptions: {
                      email: {
                        marketing: { consent: 'SUBSCRIBED' }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: LIST_ID } }
            }
          }
        })
      }
    );

    if (!response.ok) throw new Error('Subscription failed');
  }

  function publishSaved(fragranceCode) {
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    const tap = isTapContext();
    try {
      analytics.publish(tap ? 'belantara_tap_saved' : 'belantara_fragrance_saved', clean({
        ...context(),
        fragrance_code: fragranceCode,
        origin_journey_id: 'fragrance-finder',
        save_action: 'saved_fragrance',
        interest_type: 'fragrance_preference'
      }));
    } catch (_) {}
  }

  async function hydrate(form) {
    const recognized = await isRecognized(form);
    const emailWrap = form.querySelector('[data-ff-save-email]');
    const emailInput = emailWrap?.querySelector('input[name="email"]');
    const consent = form.querySelector('[data-ff-save-consent]');
    const welcome = form.querySelector('[data-ff-save-welcome]');

    if (emailWrap) emailWrap.hidden = recognized;
    if (emailInput) {
      emailInput.disabled = recognized;
      emailInput.required = !recognized;
    }
    if (consent) consent.hidden = recognized;
    if (welcome) welcome.hidden = !recognized;
  }

  function applyHeroBranding(root) {
    if (!document.getElementById('ff-tap-hero-branding')) {
      const style = document.createElement('style');
      style.id = 'ff-tap-hero-branding';
      style.textContent = `
        html.ff-tap .ff-panel--result .ff-result__media { position: relative; }
        html.ff-tap .ff-panel--result .ff-tap-hero-logo {
          position: absolute;
          z-index: 3;
          top: max(1.5rem, env(safe-area-inset-top));
          left: 50%;
          width: min(58vw, 14rem);
          height: auto;
          transform: translateX(-50%);
          filter: brightness(0) invert(1) drop-shadow(0 1px 10px rgba(18, 33, 30, .22));
          pointer-events: none;
        }
      `;
      document.head.appendChild(style);
    }

    root.querySelectorAll('.ff-panel--result .ff-result__media').forEach(media => {
      if (media.querySelector('.ff-tap-hero-logo')) return;
      const logo = document.createElement('img');
      logo.className = 'ff-tap-hero-logo';
      logo.src = TAP_LOGO;
      logo.alt = 'Belantara';
      logo.loading = 'eager';
      media.appendChild(logo);
    });
  }

  async function saveFragrance(form) {
    const error = form.querySelector('[data-ff-save-error]');
    const status = form.querySelector('[data-ff-save-status]');
    const button = form.querySelector('button[type="submit"]');
    const input = form.querySelector('input[name="email"]');
    const recognizedEmail = knownEmail(form);
    const recognized = await isRecognized(form);
    const email = normalizeEmail(recognizedEmail || input?.value);
    const fragranceCode = form.dataset.fragranceCode || '';
    const fragranceLabel = form.dataset.fragranceLabel || '';
    const consent = form.querySelector('input[name="marketing_consent"]');

    if (!recognized && !validEmail(email)) {
      if (error) error.textContent = 'That email doesn’t look right. Try again.';
      input?.focus();
      return;
    }

    if (!fragranceCode) return;

    const original = button?.textContent || 'Save this fragrance';
    if (button) {
      button.disabled = true;
      button.textContent = 'Saving…';
    }
    if (error) error.textContent = '';

    try {
      if (!recognized && consent?.checked && consentEmail() !== email) {
        await subscribe(email);
        rememberConsent(email);
      }

      const base = {
        ...context(),
        fragrance_code: fragranceCode
      };

      if (isTapContext()) {
        const brief = window.BelantaraTapBrief?.payload(base);
        if (!brief) throw new Error('Tap brief capture unavailable');

        await identify(email, {
          in_person_acquired: true,
          last_in_person_event: base.event_code,
          last_in_person_venue: base.venue_code,
          last_in_person_date: new Date().toISOString(),
          stated_favourite_fragrance: fragranceCode,
          ...brief.profile
        });

        await track('In Person — Saved Fragrance', {
          ...base,
          action: 'saved_fragrance',
          fragrance_label: fragranceLabel,
          ...brief.event
        });
      } else {
        await identify(email, {
          stated_favourite_fragrance: fragranceCode
        });

        await track('Saved Fragrance Recommendation', {
          ...base,
          action: 'saved_fragrance',
          fragrance_label: fragranceLabel
        });
      }

      if (email) rememberEmail(email);
      publishSaved(fragranceCode);

      form.dataset.saved = 'true';
      form.querySelector('[data-ff-save-email]')?.setAttribute('hidden', '');
      form.querySelector('[data-ff-save-consent]')?.setAttribute('hidden', '');
      form.querySelector('[data-ff-save-welcome]')?.setAttribute('hidden', '');
      if (button) button.textContent = 'Saved';
      if (status) {
        status.hidden = false;
        status.textContent = 'We’ll remember this fragrance for you.';
      }
    } catch (_) {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
      if (error) error.textContent = 'Something went wrong. Please try again.';
    }
  }

  function init() {
    const root = document.querySelector('[data-fragrance-finder]');
    if (!root) return;

    if (isTapContext()) applyHeroBranding(root);
    root.querySelectorAll('[data-ff-save-form]').forEach(hydrate);

    root.addEventListener('submit', event => {
      const form = event.target.closest('[data-ff-save-form]');
      if (!form) return;
      event.preventDefault();
      if (form.dataset.saved === 'true') return;
      saveFragrance(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
